import { DEFAULT_MAP_SOURCE } from '@env';

import { EsriMap } from '@lib/geo/esri';
import { GoogleMap } from '@lib/geo/google/map';

export type FsMapType<T extends string> = T extends 'google'
  ? GoogleMap
  : T extends 'esri'
  ? EsriMap
  : never;

export type MapType<T extends string> = T extends 'google'
  ? google.maps.Map
  : T extends 'esri'
  ? __esri.MapView
  : never;

export type MarkerMapType = MapType<typeof DEFAULT_MAP_SOURCE>;
export type FsMap = FsMapType<typeof DEFAULT_MAP_SOURCE>;
